// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a9Vhuob8AK_4frOz4taM {
  width: 100%;
  background-color: var(--footer-middle-block-background);
}

.zxIqTIGs2vzqFO7BrXfX {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  max-width: 90rem;
  padding: 3rem 4rem;
  margin: 0 auto
}

.zxIqTIGs2vzqFO7BrXfX .xy93F1lXVB5W1gQjEHcw {
    background: var(--store-switcher-block-footer-bg);
    border-color: var(--store-switcher-block-footer-color)
  }

.zxIqTIGs2vzqFO7BrXfX .xy93F1lXVB5W1gQjEHcw:hover:not([disabled]) {
      background: var(--store-switcher-block-footer-bg);
      color: var(--store-switcher-block-footer-color);
      border-color: var(--store-switcher-block-footer-color);
    }

.zxIqTIGs2vzqFO7BrXfX .xy93F1lXVB5W1gQjEHcw.NWdoWt2UZPB2FmZqI1Ln {
      background: var(--store-switcher-block-footer-bg);
      color: var(--store-switcher-block-footer-color);
      border-color: var(--store-switcher-block-footer-color);
    }

.zxIqTIGs2vzqFO7BrXfX .ikiR0KYxfuDUhm_NAxzD {
    color: var(--store-switcher-block-footer-color);
  }

.PMWHQM8X4EkeVzx4HDFV {
  display: flex;
  flex-direction: column;
}

.VZRal9ejqp6T7CmINKuy {
  margin-bottom: 2rem;
}

.C11FXR_MifdOR1tXsZfV {
  margin-bottom: 1rem;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .zxIqTIGs2vzqFO7BrXfX {
    padding: 3rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .zxIqTIGs2vzqFO7BrXfX {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    padding: 3.125rem 2rem 5.5rem 2rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .zxIqTIGs2vzqFO7BrXfX {
    display: flex;
    flex-direction: column;
    padding: 3rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterMiddlePart/FooterMiddlePart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,uBAAuB;EACvB,gBAAiB;EACjB,kBAAkB;EAClB;AAsBF;;AApBE;IACE,iDAAiD;IACjD;EAaF;;AAXE;MACE,iDAAiD;MACjD,+CAA+C;MAC/C,sDAAsD;IACxD;;AAEA;MACE,iDAAiD;MACjD,+CAA+C;MAC/C,sDAAsD;IACxD;;AAGF;IACE,+CAA+C;EACjD;;AAGF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;EACE;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAA4B;EAC9B;AACF;;AAEA;;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  background-color: var(--footer-middle-block-background);\n}\n\n.footerMiddlePart {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-rows: 1fr;\n  max-width: 1440px;\n  padding: 48px 64px;\n  margin: 0 auto;\n\n  & .storeSwitcherButton {\n    background: var(--store-switcher-block-footer-bg);\n    border-color: var(--store-switcher-block-footer-color);\n\n    &:hover:not([disabled]) {\n      background: var(--store-switcher-block-footer-bg);\n      color: var(--store-switcher-block-footer-color);\n      border-color: var(--store-switcher-block-footer-color);\n    }\n\n    &.disabled {\n      background: var(--store-switcher-block-footer-bg);\n      color: var(--store-switcher-block-footer-color);\n      border-color: var(--store-switcher-block-footer-color);\n    }\n  }\n\n  & .textClassName {\n    color: var(--store-switcher-block-footer-color);\n  }\n}\n\n.sectionWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.lastColumn {\n  margin-bottom: 32px;\n}\n\n.text {\n  margin-bottom: 16px;\n}\n\n@media (--desktop-small) {\n  .footerMiddlePart {\n    padding: 48px;\n  }\n}\n\n@media (--tablet) {\n  .footerMiddlePart {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    padding: 50px 32px 88px 32px;\n  }\n}\n\n@media (--mobile) {\n  .footerMiddlePart {\n    display: flex;\n    flex-direction: column;\n    padding: 48px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `a9Vhuob8AK_4frOz4taM`,
	"footerMiddlePart": `zxIqTIGs2vzqFO7BrXfX`,
	"storeSwitcherButton": `xy93F1lXVB5W1gQjEHcw`,
	"disabled": `NWdoWt2UZPB2FmZqI1Ln`,
	"textClassName": `ikiR0KYxfuDUhm_NAxzD`,
	"sectionWrapper": `PMWHQM8X4EkeVzx4HDFV`,
	"lastColumn": `VZRal9ejqp6T7CmINKuy`,
	"text": `C11FXR_MifdOR1tXsZfV`
};
export default ___CSS_LOADER_EXPORT___;
